import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration for prayer-army-app project
const firebaseConfig = {
  apiKey: "AIzaSyCO25N4_VvPGZHr7mRaRyyz0IIO9ZbJN4s",
  authDomain: "prayer-army-app.firebaseapp.com",
  projectId: "prayer-army-app",
  storageBucket: "prayer-army-app.firebasestorage.app",
  messagingSenderId: "1056375873886",
  appId: "1:1056375873886:web:fb995dbb4546124db8afcf",
  measurementId: "G-10PDDHESBM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
